import { autoinject, bindable } from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import { Claims } from "../../../../../constants/authentication/claims";
import { UserClaimsService } from "../../../../../services/authentication/user-claims.service";
import { UserClientService } from "../../../../../services/authentication/user-client.service";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { CustomerService } from "../../../../../services/modules/customer-client.service";
import { ManageRightShipUsersClientService } from "../../../../../services/modules/righship-qi-manage-users.service";

@autoinject()
export class MoveUserDialog {

    private canManageLockedRoles: boolean;
    
    @bindable
    public selectedCustomerId: number;

    public selectedBusinessUnitId: number;
    public selectedRoleId: number;
    public buParams: string;
    public isMovetoRSSelected: boolean;
    public userIds: number[];
    public itemSource: any[] = [];
    public branchId: number;
    public isDisabled: boolean = false;
    public currentBranchId: number;
    public initialGet: boolean;
    public initialRoleId: number;
    public banner: string;
    public onMoved: () => void;

    constructor(
        private dialogClientService: DialogClientService,
        private userClaimService: UserClaimsService,
        private userClientService: UserClientService,
        private manageUsersService: ManageRightShipUsersClientService,
        private notificationService: NotificationClientService,
        private i18N: I18N,
        private customerService: CustomerService
    ) { 
        this.canManageLockedRoles = userClaimService.hasPermission(Claims.CanManageLockedRoles);
     }

    activate({customerId, businessUnitId, userIds, branchId, roleId, onMoved}){
        this.selectedBusinessUnitId = businessUnitId;
        this.userIds = userIds;
        this.branchId = branchId;
        this.selectedCustomerId = customerId;
        this.selectedRoleId = roleId;
        this.initialRoleId = roleId;
        this.initialGet = true;
        this.onMoved = onMoved;
        this.selectedCustomerIdChanged();
    }

    selectedCustomerIdChanged(){
        const canViewAll = this.userClaimService.hasPermission(Claims.RightShipUser);

        const customerIdParam = this.selectedCustomerId ? this.selectedCustomerId.toString() : 'null';
        const userIdParam = canViewAll ? 'null' : this.userClientService.currentUser.id.toString();
        this.buParams = customerIdParam + ',' + userIdParam;

        this.customerService.getCustomer(this.selectedCustomerId).then(x => {
            const item = x.customer;
            if (item) {
                this.getRoles(item.branchId);
                this.currentBranchId = item.branchId;
                this.initialGet = false;
                this.banner = item.customerNote;
            }
        }, null);
    }

    saveUser() {
        if(this.isMovetoRSSelected){
            if (!this.selectedRoleId) {
                this.notificationService.show("Role must have a value", "", NotificationType.Error, 5000);
                return;
            }
            
            this.manageUsersService.moveUserToNewCustomer({
                userIds: this.userIds,
                customerId: 0,
                businessUnitId: 0,
                roleId: this.selectedRoleId,
                isMoveToRSUser: true
            }).then(response=> {
                if(response.isSuccess){
                    this.notificationService.show(response.message, "", NotificationType.Success, 5000);
                }
                if (this.onMoved){
                    this.onMoved();
                }
            }, null).catch(() => {
                this.notificationService.show(this.i18N.tr('unknown-error-text'), "", NotificationType.Error, 5000);
            })
            this.dialogClientService.hide();
        } else {
            if(!this.selectedCustomerId){
                this.notificationService.show("Customer must have a value", "", NotificationType.Error, 5000);
                return;
            } else if (!this.selectedBusinessUnitId) {
                this.notificationService.show("Business Unit must have a value", "", NotificationType.Error, 5000);
                return;
            } else if (!this.selectedRoleId) {
                this.notificationService.show("Role must have a value", "", NotificationType.Error, 5000);
                return;
            }
    
            this.manageUsersService.moveUserToNewCustomer({
                userIds: this.userIds,
                customerId: this.selectedCustomerId,
                businessUnitId: this.selectedBusinessUnitId,
                roleId: this.selectedRoleId,
                isMoveToRSUser: false
            }).then(response=> {
                if(response.isSuccess){
                    this.notificationService.show(response.message, "", NotificationType.Success, 5000);
                }
                if (this.onMoved){
                    this.onMoved();
                }
            }, null).catch(() => {
                this.notificationService.show(this.i18N.tr('unknown-error-text'), "", NotificationType.Error, 5000);
            })
    
            this.dialogClientService.hide();
        }
    }

    cancel() {
        this.dialogClientService.hide();
    }

    getRoles(branchId: number) {
        this.manageUsersService.getBranchRoles(branchId)
            .then(response=> {
                this.itemSource = [];
                if(response.length > 0) {
                    response.filter(x => x.isActive && (!x.isLocked || (x.isLocked && this.canManageLockedRoles))).forEach(element => {
                        const toAddItem = {
                            name: element.roleName,
                            value: element.roleId
                        }
                        this.itemSource.push(toAddItem);
                    });
                }
            }, null);
    }

    onSelectedChanged() {
        this.isDisabled = !this.isDisabled;
        if(this.isDisabled)  {
            this.getRoles(23);
        } else {
            this.getRoles(this.currentBranchId)
        }
    }
}